var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-details"},[_c('div',{staticClass:"back_btn"},[_c('div',{staticClass:"icon_btn",on:{"click":_vm.backBtn}},[_c('i',{staticClass:"el-icon-back"}),_c('span',[_vm._v("返回")])])]),_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.notice)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }